const WIDGETS_PREFIX = '@@widgets/'

export const WIDGETS_ACTION_TYPES = {
    FETCH_LIST_REQUEST: `${WIDGETS_PREFIX}FETCH_LIST_REQUEST`,
    FETCH_LIST_SUCCESS: `${WIDGETS_PREFIX}FETCH_LIST_SUCCESS`,
    FETCH_LIST_FAILURE: `${WIDGETS_PREFIX}FETCH_LIST_FAILURE`,
}